import axios, { type AxiosInstance } from "axios"
import { getExhibitionHeader } from "../utils/exhibitionContext";
import type { BadgeEntryVerification, PaginatedResponse } from "../Component/Application/BadgeEntryVerification/types"

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    
    Object.assign(config.headers, getExhibitionHeader());}
    return config
  },
  (error) => Promise.reject(error),
)

export const BadgeVerificationService = {
  getAll: async (
    page = 1,
    pageSize = 10,
    search = "",
    dateFrom = "",
    dateTo = "",
  ): Promise<PaginatedResponse<BadgeEntryVerification>> => {
    const response = await api.get("/api/badges/badge-verifications/", {
      params: { page, page_size: pageSize, search, date_from: dateFrom, date_to: dateTo },
    })
    return response.data
  },

  getById: async (id: number): Promise<BadgeEntryVerification> => {
    const response = await api.get(`/api/badges/badge-verifications/${id}/`)
    return response.data
  },
}
